module finadai.lang {
  export var NAME = 'finadai.lang';
  function i18nConfig($translateProvider) {

    $translateProvider.useStaticFilesLoader({
      prefix: 'assets/i18n/',
      suffix: '.json'
    });

    $translateProvider.preferredLanguage('es');
    $translateProvider.useSanitizeValueStrategy(null);
  }

  function LangCtrl($scope, $translate) {
    $scope.lang = 'Español';

    this.openMenu = function($mdOpenMenu, ev) {
      var originatorEv = ev;
      $mdOpenMenu(ev);
    };

    $scope.langs = [
        'Español',
        'English',
        '中文',
        '日本語'
    ]
    
    $scope.setLang = function(index) {
      var lang = this.langs[index];
      switch (lang) {
        case 'English':
          $translate.use('en');
          break;
        case 'Español':
          $translate.use('es');
          break;
        case '中文':
          $translate.use('zh');
          break;
        case '日本語':
          $translate.use('ja');
          break;
      }
      return $scope.lang = lang;
    };

    $scope.getFlag = function() {
      var lang;
      lang = $scope.lang;
      switch (lang) {
        case 'English': return 'flags-american';
        case 'Español': return 'flags-spain';
        case '中文': return 'flags-china';
        case '日本語': return 'flags-japan';
      }
    };
  }
  export function run(){
    var lang = angular.module(NAME, ['pascalprecht.translate']);
    lang.config(i18nConfig);
    lang.controller('LangCtrl', LangCtrl);
  }
}
finadai.lang.run();